// src/Productos/modal/product-modal.jsx
import React from 'react';
import { Modal, Box, Typography } from '@mui/material';
import './product-modal.css';

const ProductModal = ({ open, handleClose, type, content }) => {
  const isNutritional = type === 'nutritional';
  
  return (
    <Modal open={open} onClose={handleClose} className="product-modal">
      <Box className="modal-container">
        <Typography variant="h6" align="center" className="modal-title">
          {isNutritional ? 'Tabla Nutrimental' : 'Ingredientes'}
        </Typography>
        {isNutritional ? (
          <>
            <Box className="nutrition-table">
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="caption" fontWeight="bold">
                  TAMAÑO DE LA PORCIÓN <br />
                  {content.energetico_envase.map((porcion, index) => (
                    <span key={index}>{porcion}<br /></span>
                  ))}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption">CONTENIDO ENERGÉTICO</Typography>
                <Typography variant="caption">{content.contenido_energetico}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption">PROTEÍNAS</Typography>
                <Typography variant="caption">{content.proteinas}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption">GRASAS TOTALES</Typography>
                <Typography variant="caption">{content.grasas_totales}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption" fontWeight="bold">GRASAS SATURADAS</Typography>
                <Typography variant="caption" fontWeight="bold">{content.grasas_saturadas}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption" fontWeight="bold">GRASAS TRANS</Typography>
                <Typography variant="caption" fontWeight="bold">{content.grasas_trans}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption">CARBOHIDRATOS DISPONIBLES</Typography>
                <Typography variant="caption">{content.hidratos_carbono}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption">AZÚCARES</Typography>
                <Typography variant="caption">{content.azucares}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption" fontWeight="bold">AZÚCARES AÑADIDOS</Typography>
                <Typography variant="caption" fontWeight="bold">{content.azucar_anadido}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption">FIBRA DIETÉTICA</Typography>
                <Typography variant="caption">{content.fibra_dieta}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 0.5 }}>
                <Typography variant="caption" fontWeight="bold">SODIO</Typography>
                <Typography variant="caption" fontWeight="bold">{content.sodio}</Typography>
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Box className="ingredients-table">
              <Typography variant="caption">
                  {content}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default ProductModal;
